import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../store/store';
import { userActions } from './user.actions';

export interface userState {
  value: any;
  status: 'idle' | 'loading' | 'failed';
}


const createUserSlice = createSlice({
  name: "createUsers",
  initialState: {
    createdUserData: null,
    pagination: {},
    error: "",
    loading: false,
    validationError: [],
    userDetails: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
       // -------- cases of Create User api data -------
       .addCase(userActions.createUsersAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;
        state.validationError = [];
      })
      .addCase(userActions.createUsersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.createdUserData = action?.payload?.data?.message;
        state.error = "";
      })
      .addCase(userActions.createUsersAction.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action?.payload?.data?.message;
      })

      // -------- cases of get User details api data -------
      .addCase(userActions.getUserDetailsAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;

        state.userDetails = null;
      })
      .addCase(userActions.getUserDetailsAction.fulfilled, (state, action) => {
        state.error = "";
        state.loading = false;

        state.userDetails = action?.payload?.data?.data;
      })
      .addCase(userActions.getUserDetailsAction.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action?.payload?.data?.message;

        state.userDetails = null;
      });
  },
  
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const token = (state: RootState) => state.login.token;


export default createUserSlice.reducer;
